// extracted by mini-css-extract-plugin
export default {"container":"styles__container___IXOQV","text":"styles__text___Jun+v"};